module.exports = __webpack_public_path__ + "media/images/pic/bialoleka/hero-adults-cd1aab26cf812fb6a61fbb0aed3925ca.png";